<template>
  <!-- ======= About Us Section ======= -->
  <section id="about" class="about">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 order-1 order-lg-2">
          <div class="container">
            <div
              id="carouselExampleCaptions"
              class="carousel slide"
              data-bs-ride="carousel"
            >
              <div class="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carouselExampleCaptions"
                  v-for="key in newsCount"
                  :key="key"
                  :data-bs-slide-to="key - 1"
                  :class="{ active: key === 1 }"
                  :aria-current="key === 1 ? true : ''"
                  :aria-label="'Slide ' + key"
                ></button>
              </div>
              <div class="carousel-inner">
                <div
                  class="carousel-item"
                  v-for="(item, key) in news"
                  :key="key"
                  :class="{ active: key === 0 }"
                >
                  <a :href="item.path">
                    <div
                      class="newsPic"
                      :style="'background-image: url(' + item.img + ');'"
                    ></div>
                  </a>
                  <div class="carousel-caption d-none d-md-block">
                    <h5>
                      {{ item.title }}
                    </h5>
                    <p>
                      {{ item.author }}
                    </p>
                  </div>
                </div>
              </div>
              <button
                class="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleCaptions"
                data-bs-slide="next"
              >
                <span
                  class="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1">
          <p class="about-name">林宗宏 Tsung-Hung Lin</p>
          <h4 class="section-name-CHT">國立勤益科技大學 資訊工程系 教授</h4>
          <p class="section-name-CHT">
            Dep. of Computer Science and Information Engineering
          </p>
          <p class="section-name-CHT">
            National Chin-Yi University of Technology
          </p>
          <p class="about-describe">專長</p>
          <p class="about">
            工控資安/人工智慧/智慧農業物聯網/資通訊安全/資料科學
          </p>
          <p class="about">大數據/區塊鏈/XR(AR/VR/MR)</p>
          <br />
          <div class="teacher_logo">
            <a
              v-for="(item, index) in teacher_logo"
              :key="index"
              :href="item.link"
              target="_blank"
            >
              <div
                :id="item.title"
                :style="'background-image:url(' + item.path + ');'"
              ></div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="col-lg- order-1 order-lg-2">
    <div class="section-title">
      <h2>相關成果影片</h2>
    </div>
    <iframe
      width="800"
      height="500"
      src="https://www.youtube.com/embed/TcRetZ5Ewlk"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
  <br /><br />
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-sm-12" v-for="(item, key) in youtube" :key="key">
        <iframe
          width="500"
          height="250"
          :src="item"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
  <br />
  <!-- End About Us Section -->
  <contact />
</template>

<script>
// @ is an alias to /src
import contact from "../components/contact.vue";

export default {
  name: "Home",
  components: {
    contact,
  },
  data() {
    return {
      teacher_logo: [
        {
          title: "Volunteer",
          path: require("../assets/img/Duke_Volunteer_111.png"),
          link: "https://vol.mohw.gov.tw/vol2/honor/index",
        },
        {
          title: "research_id",
          path: require("../assets/img/ResearcherID.gif"),
          link: "https://www.webofscience.com/wos/author/record/204316",
        },
      ],
      youtube: [
        "https://www.youtube.com/embed/Z72Chkg-dKg",
        "https://www.youtube.com/embed/T_FEQq91qPk",
        "https://www.youtube.com/embed/-1vqvl53dSY",
        "https://www.youtube.com/embed/RjApouLznWo",
      ],
      news: [
        {
          path: "https://www.chinatimes.com/realtimenews/20220913004589-260405?chdtv",
          img: require("../assets/img/news05.png"),
          title: "協助解決農業問題 勤益科大成立USR推動辦公室",
          author: "中時新聞網",
        },
        {
          path: "https://news.ltn.com.tw/news/life/breakingnews/3649166",
          img: require("../assets/img/news01.jpeg"),
          title: "「帶口罩也會笑」！ 科大生助原鄉打造智慧溫室 農產量倍增",
          author: "自由時報",
        },
        {
          path: "https://www.ner.gov.tw/news/6124aff0ff90ff00074b4902",
          img: require("../assets/img/news02.jpeg"),
          title: "蹲點原民部落 勤益科大學生自組農業物聯網打造智慧溫室",
          author: "國立教育廣播電台",
        },
        {
          path: "https://www.news.high.edu.tw/feature_story/content.php?cid=170&did=518",
          img: require("../assets/img/news03.jpeg"),
          title: "國立勤益科技大學 學費資助，海外招生回響大",
          author: "高教創新雜誌(高教司/技職司)",
        },
        {
          path: "https://news.ltn.com.tw/news/life/breakingnews/4056644",
          img: require("../assets/img/news06.jpeg"),
          title: "勤益科大USR推動辦公室成立 協助解決產銷失衡、人力不足",
          author: "自由時報",
        },
        {
          path: "https://www.heeact.edu.tw/1151/1165/43078/43085/53556/55765/",
          img: require("../assets/img/news04.png"),
          title: "國立勤益科技大學推動大學社會責任之作法與成效",
          author: "高等教育評鑑中心",
        },
      ],
      newsCount: 6,
    };
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "NotoSansTC_Regular";
  src: url("../assets/font/NotoSansTC-Regular.otf") format("truetype");
}

@font-face {
  font-family: "NotoSansTC_Bold";
  src: url("../assets/font/NotoSansTC-Bold.otf") format("truetype");
}

.newsPic {
  width: 100%;
  height: 400px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.teacher_logo {
  display: flex;

  & > a {
    width: 50%;

    & > div {
      background-repeat: no-repeat;
      background-position: left;
    }

    & #research_id {
      height: 10vh;
      background-size: contain;
    }

    & #Volunteer {
      height: 18vh;
      background-size: contain;
    }
  }
}

/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "NotoSansTC", sans-serif;
  color: #777;
}

a {
  text-decoration: none;
  color: #43aea0;
}

a:hover {
  color: #00d3b8;
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6,
.font-primary {
  font-family: "NotoSansTC_Regular", sans-serif;
}

/*--------------------------------------------------------------
# Sections General
--------------------------------------------------------------*/
section {
  padding: 100px;
}

.research-code {
  font-family: "NotoSansTC_Bold";
  color: #0000ff;
  text-align: left;
}

.section-name-CHT {
  text-align: left;
  font-size: 2vh;
}

.section-bg {
  background-color: #f2f9f8;
}

.section-title {
  text-align: center;
  padding-bottom: 30px;
}

.section-title h2 {
  font-size: 32px;
  font-weight: 300;
  margin-bottom: 20px;
  padding-bottom: 0;
  color: #555;
}

.section-title p {
  margin-bottom: 0;
}

/*--------------------------------------------------------------
# About Us
--------------------------------------------------------------*/
.about-name {
  font-family: "NotoSansTC_Bold";
  font-size: 5vh;
  text-align: left;
}

.about-research-code {
  font-family: "NotoSansTC_Bold";
  color: #0000ff;
  font-size: 2vh;
  text-align: left;
}

.about-describe {
  font-family: "NotoSansTC_Bold";
  font-size: 2.5vh;
  text-align: left;
}

.about h3 {
  font-weight: 400;
  font-size: 26px;
}

.about ul {
  list-style: none;
  padding: 0;
}

.about ul li {
  padding-bottom: 10px;
}

.about ul i {
  font-size: 22px;
  padding-right: 4px;
  color: #70b9b0;
  line-height: 0;
}

.about p {
  text-align: left;
  margin-bottom: 0;
}
</style>
